import { instructionDownloadPath } from '../constants/apiEndpoints';
import { createNotification } from '../utils';
import apiService from '../utils/apiService';
import { notificationTypeError } from '../constants/globals';

const downloadInstructionSuccessfully = (data, documentName) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', documentName);
  document.body.appendChild(link);
  link.click();
  URL.revokeObjectURL(url);
};

export const downloadInstruction = (message) => async (dispatch) => {
  return apiService
    .getFromFile(instructionDownloadPath())
    .then((response) => {
      dispatch(
        downloadInstructionSuccessfully(
          response.data,
          'Корисничко упутство.docx'
        )
      );
    })
    .catch((err) => {
      if (err?.response?.status === 500) {
        createNotification(
          notificationTypeError,
          message.instruction,
          message.unsuccessfulDownload
        );
      }
    });
};
